import Servicio from "./Servicio"
import { Shield, Code, Scale, Megaphone, Cog } from "lucide-react"
import { useTranslation } from "react-i18next"

const Servicios = () => {
  const [t, i18n] = useTranslation("global")
  const servicios = [
    {
      icono: <Shield className="w-8 h-8 md:w-10 md:h-10" strokeWidth={1.5} />,
      titulo: t("servicios.title-seguridad"),
      descripcion: t("servicios.texto-seguridad"),
    },
    {
      icono: <Code className="w-8 h-8 md:w-10 md:h-10" strokeWidth={1.5} />,
      titulo: t("servicios.title-desarrollo"),
      descripcion: t("servicios.texto-desarrollo"),
    },        
    {
      icono: <Scale className="w-8 h-8 md:w-10 md:h-10" strokeWidth={1.5} />,
      titulo: t("servicios.title-derecho"),
      descripcion: t("servicios.texto-derecho"),
    },
    {
      icono: <Megaphone className="w-8 h-8 md:w-10 md:h-10" strokeWidth={1.5} />,
      titulo: t("servicios.title-marketing"),
      descripcion: t("servicios.texto-marketing"),
    },
    {
      icono: <Cog className="w-8 h-8 md:w-10 md:h-10" strokeWidth={1.5} />,
      titulo: t("servicios.title-soporte"),
      descripcion: t("servicios.texto-soporte"),
    },
  ]

  return (
    <div id="servicios" className="mx-auto flex justify-center items-center">
      <div className="w-full justify-center mx-auto px-4">
        <h1 className="text-3xl md:text-4xl  w-full font-messina tracking-wide text-white mt-10 mb-2">
          {t("servicios.title")}
        </h1>
        <div className="h-1 w-20 bg-gradient-to-r from-gray-500 to-transparent mb-10"></div>

        <div className="bg-fondo-opaco bg-opacity-30 rounded-2xl flex flex-col mt-10 p-8 min-h-[600px] border border-slate-700/50 backdrop-blur-sm">
          <div className="flex flex-wrap justify-center gap-6 w-full">
            {servicios.map((servicio, i) => (
              <div key={i} className="w-full md:w-[30%] lg:w-[30%] min-w-[250px] max-w-[400px] flex-grow">
                <Servicio icono={servicio.icono} titulo={servicio.titulo} descripcion={servicio.descripcion} />
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  )
}

export default Servicios
